import { makeStyles } from '@material-ui/core'
import { ReactComponent as Hospital } from 'src/assets/PolicyTile_Images/Group10.svg'
import { CircularProgress } from '@mui/material'
import { useQuery } from '@apollo/client'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { COLORS } from 'src/utils/Themes/colors'
import { TPA } from 'src/services/individualService'

const CallToAction = ({ tpaId }) => {
  const classes = useStyles()

  const { loading, error, data } = useQuery(TPA(tpaId), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  if (loading)
    return (
      <div className='loadingContainer'>
        <CircularProgress />
      </div>
    )
  if (error) return <GraphQlErrors error={error} />
  return (
    <div className={classes.root}>
      <div className={classes.icon}>
        <Hospital />
      </div>
      <a
        href={data?.getTpaData?.length !== 0 && data?.getTpaData?.[0]?.url}
        target='_blank'
        className={classes.textContainer}
        rel='noreferrer'
      >
        <div className={classes.text} id='text'>
          Network Hospital List
        </div>
      </a>
    </div>
  )
}

export default CallToAction

const useStyles = makeStyles({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
  },
  icon: {
    borderRadius: '8px',
    // background: "#F1F1F1",
    // padding: "10px",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // marginRight: "10px",
    '& img': {
      flexShrink: 0,
      width: '24px',
      marginRight: '10px',
    },
    '& svg': {
      flexShrink: 0,
      width: '24px',
      marginRight: '10px',
    },
  },
  textContainer: {
    textDecoration: 'none',
  },
  text: {
    fontSize: '16px',
    color: COLORS.MEDIUM_LIGHTBLUE,
    fontWeight: 'bold',
    // textDecoration: "underline",
    // cursor: "pointer",
    '&:hover': {
      textDecoration: 'none',
    },
  },
  options: {
    marginLeft: '10px',
    paddingRight: '10px',
    '& .MuiInput-root': {
      border: `1px solid ${COLORS.BLACK01}`,
      borderRadius: '10px',
    },
    '& .MuiInput-underline:before': {
      display: 'none',
    },
    '& .MuiInput-underline.Mui-focused:after': {
      transform: 'scaleX(0)',
    },
    '& svg': {
      color: COLORS.DARK_PINK,
    },
  },
})
